/*
 * @format
 */

import { all, call, delay, race, take } from 'redux-saga/effects';
import uuid from 'uuid/v4';
import * as messages from '../web_socket_messages/messages';
import * as types from '../action-types';
import { GLOBAL_TIMEOUT } from '../utils/timeout';

function* sendAndWaitAck(action) {
  yield call(action.sendWsMessage, action.message);

  const response = yield take(
    a =>
      (a.type === types.WEBSOCKET_PRT_SETTINGS_UPDATE_RECEIVED ||
        a.type === types.WEBSOCKET_PRT_SETTINGS_UPDATE_REJECTED) &&
      a.data.requestId === action.message.data.requestId,
  );

  return response;
}

function* checkPrtSettingIsSet(action) {
  let settingIsSet = false;
  const { siId, prtId, configName, configValue, lockOn } = action.message.data;
  while (!settingIsSet) {
    const { data } = yield take([types.WEBSOCKET_LIVE_RECEIVED]);
    if (data) {
      if (data.home.zones && data.home.zones.length > 0) {
        if (data.home.id === siId) {
          const device = data.home.zones.find(i =>
            i.zoneId.find(n => n === prtId),
          );
          if (device) {
            let convertConfigValue = device[configName];

            // check if the setting has been changed
            let foundSetting = Object.prototype.hasOwnProperty.call(
              device,
              configName,
            );

            if (lockOn !== undefined) {
              convertConfigValue = device.childLock;
              // check if the setting has been changed
              foundSetting = Object.prototype.hasOwnProperty.call(
                device,
                'childLock',
              );
            } else {
              if (configName === 'optimisedStopEndabled') {
                convertConfigValue = device.optimisedStopEnabled;
                // check if the setting has been changed
                foundSetting = Object.prototype.hasOwnProperty.call(
                  device,
                  'optimisedStopEnabled',
                );
              } else if (configName === 'optimisedStopEnabled') {
                convertConfigValue = device.optimisedStopEnabled;
                // check if the setting has been changed
                foundSetting = Object.prototype.hasOwnProperty.call(
                  device,
                  'optimisedStopEnabled',
                );
              } else {
                convertConfigValue = device[configName];
                // check if the setting has been changed
                foundSetting = Object.prototype.hasOwnProperty.call(
                  device,
                  configName,
                );
              }
              if (typeof convertConfigValue === 'boolean') {
                convertConfigValue = convertConfigValue ? '1' : '0';
              } else if (typeof convertConfigValue === 'number') {
                convertConfigValue = convertConfigValue.toString();
              }
            }

            if (
              foundSetting &&
              (convertConfigValue === configValue ||
                convertConfigValue === lockOn)
            ) {
              settingIsSet = true;
            }
          } else {
            console.log(`❌ home ${siId} zone ${prtId} not found`);
          }
        }
      }
    }
  }
  return settingIsSet;
}

function* prtSettingsQueue() {
  while (true) {
    const action = yield take(types.PRT_COPY_SETTING_STARTED);

    const copySettings = action.newSettings;
    let processing = copySettings.length > 0;

    if (processing) {
      while (processing) {
        const setting = Object.keys(copySettings[0])[0];
        const settingValue = copySettings[0][Object.keys(copySettings[0])];
        yield call(action.onStart, setting);

        const requestId = uuid();

        const newAction = action;

        newAction.message = messages.getPrtMessage(
          action.homeId,
          action.zoneId,
          requestId,
          setting,
          settingValue,
          action.deviceToken,
        );

        const { timeout, response } = yield race({
          timeout: delay(GLOBAL_TIMEOUT),
          response: call(sendAndWaitAck, newAction),
        });

        if (response && response.data) {
          if (response.data.state === 'complete') {
            const waitPeriod = GLOBAL_TIMEOUT; // 30 sec
            const prtSettingResponse = yield race({
              prtSettingResponse: call(checkPrtSettingIsSet, newAction),
              timeout: delay(waitPeriod),
            });
            if (
              (prtSettingResponse && prtSettingResponse.timeout) ||
              prtSettingResponse.response === false
            ) {
              yield call(action.onTimeout, setting);
              processing = false;
            } else {
              // remove completed copy setting
              copySettings.shift();

              // check if the copySetting is empty
              if (copySettings.length === 0) {
                yield call(action.onResolve);
                processing = false;
              }

              yield delay(5000);
            }
          } else if (response.data.state === 'rejected') {
            yield call(action.onError, setting);
            processing = false;
          }
        }

        if (timeout) {
          yield call(action.onTimeout, setting);
          processing = false;
        }
      }
    } else {
      yield call(action.onResolve);
    }
  }
}

function* prtCopySettings() {
  yield all([call(prtSettingsQueue)]);
}

export default prtCopySettings;
